export const EXTRA_CHARGE_TYPES = {
    BreakBulk: {
        "Border & Customs Related Charges": [
            "Export customs clearance",
            "Customs documentation & handling fee",
            "T1 / Transit document cost",
            "Guarantee / bond / customs deposit",
            "Customs inspection / red line handling",
            "X-ray / scanning fee",
            "Weighbridge fee",
            "Brokerage extra services",
        ],

        "Loading, Waiting & Operational Accessorials": [
            "Loading / unloading charges",
            "Forklift / crane / labor",
            "Waiting / detention",
            "Appointment / time-slot booking",
            "Yard/terminal entrance fee",
            "Re-positioning / extra pick-up",
            "Failed loading / truck return",
        ],

        "Route & Regulatory Surcharges": [
            "Toll / motorway / bridge fees",
            "Ro-Ro / ferry fees",
            "Permit / special route permissions",
            "Weekend / holiday driving restrictions cost",
            "Police escort / pilot car",
            "Low emission zone / city access fee",
        ],

        "Equipment, Cargo & Packaging Related": [
            "Pallet exchange / pallet cost",
            "Lashing / securing materials",
            "Dunnage / packing support",
            "Tarpaulin / straps / corner protectors",
            "ADR equipment requirements",
            "Temperature logger / reefer monitoring",
        ],

        "Risk, Incident & Financial Add-ons": [
            "Cargo insurance (All-risk / CMR)",
            "War risk / high-risk area surcharge",
            "Demurrage-like stand-by due to border queues",
            "Re-delivery / address change",
            "Storage / warehouse / cross-dock",
            "Bank charges / payment fees",
            "Currency difference / FX adjustment",
        ],
    },

    OOG: {
        "Permits & Regulatory": [
            "Oversize/Overweight Route Permit Fees",
            "Escort Permit / Police Permit",
            "Night / Weekend Travel Permit",
            "Road Authority / Municipality Fees",
            "Special Structure Crossing Approval",
            "Documentation & Permit Handling Fee",
        ],

        "Escort, Survey & Engineering": [
            "Pilot Car / Escort Vehicle Charges",
            "Police Escort Charges",
            "Route Survey / Physical Route Inspection",
            "Engineering Study / Method Statement",
            "Traffic Management Plan (TMP)",
            "Site Survey (Origin/Destination)",
        ],

        "Equipment & Handling": [
            "Crane Mobilization / Demobilization",
            "Heavy Lift Crane Hourly Charges (Minimum Hours)",
            "Forklift / Reach Stacker / Telehandler",
            "Jack & Slide / Skidding System",
            "SPMT / Modular Trailer (Extra Axles/Modules)",
            "Lowbed / Extendable Trailer Surcharge",
            "Rigging & Lifting Gear Rental",
            "Temporary Supports / Dunnage / Timbering",
        ],

        "Loading/Unloading Time & Standby": [
            "Loading/Unloading Waiting Time (Beyond Free Time)",
            "Vehicle Standby / Idle Time",
            "Crew Overtime (Night/Weekend)",
            "Rescheduling / Slot Change Fee",
            "Failed Attempt / Dry Run",
        ],

        "Route Constraints & Special Moves": [
            "Detour / Longer Route Surcharge",
            "Bridge/Tunnel Toll Surcharge",
            "Ferry / Barge Crossing Costs",
            "Road Closure / Lane Closure Charges",
            "Street Furniture Removal/Reinstatement",
            "Utility Handling (Power/Telecom)",
            "Tree Trimming / Civil Works",
        ],

        "Storage, Yard & Terminal": [
            "Staging Yard Rental",
            "Heavy Cargo Handling at Terminal",
            "Port/Terminal Appointment Fee",
            "Demurrage/Detention (If Applicable)",
            "Laydown Area Preparation",
        ],

        "Packaging, Securing & Technical": [
            "Lashing & Securing Materials",
            "Welding / Fabrication for Securing",
            "Custom Cradles / Saddles / Frames",
            "Heat Treatment / Fumigation (Wood)",
            "Packing / Repacking / Unpacking",
            "Shoring / Bracing",
        ],

        "Risk, Insurance & Compliance": [
            "Additional Cargo Insurance Premium",
            "Third-Party Liability Insurance",
            "HSE Requirements / Safety Officer",
            "Security Escort / Site Security",
            "Weather Standby",
        ],

        "Customs, Border & Trade Compliance": [
            "Customs Brokerage Fee",
            "Transit Customs (T1/T2) Handling Fee",
            "Temporary Import/Export Handling (ATA Carnet)",
            "Customs Consultancy / Compliance Review",
            "Customs Inspection Fee",
            "X-Ray / Scanner Fee",
            "Sampling / Laboratory Analysis Fees",
            "Weighbridge / Verification Fees",
            "Joint Inspection / 3rd Party Survey",
            "Customs Overtime at Port/Terminal",
            "Customs Attendance Fee",
            "Port Security & Gate Pass Fees",
            "Terminal OOG Handling Surcharge",
            "Bonded Warehouse Charges",
            "Bonded Handling (Load/Unload)",
            "Yard Storage in Bonded Zone",
            "Relocation/Shifting in Bonded Area",
            "Disbursement / Advance Payment Fee",
            "Customs Bond / Guarantee Costs",
            "Demurrage/Detention due to Customs Hold",
            "Penalty / Administrative Fine",
            "Amendment / Correction Fee",
            "Certificate / Legalization Fees (CO, EUR.1, A.TR etc.)",
            "Translation & Notary Fees",
            "Special Import License / Permit Fees",
            "Chamber of Commerce / Registry Fees",
            "HS Code Classification Support",
            "Border Waiting / Queue Surcharge",
            "Sealing / Resealing Fees",
            "Transit Document Re-issuance",
            "Border Facility Handling Fees",
        ],
    },

    Multimodal: {
        "Terminal & Port Surcharges": [
            "Terminal Storage",
            "Demurrage",
            "Detention",
            "Port Congestion Surcharge",
            "Late Gate-in / Late Gate-out Fee",
            "Roll-over / Re-booking Fee",
            "Weighbridge / VGM Re-weigh",
            "ISPS / Port Security Fee",
            "OOG Handling / Special Lift",
            "Re-handling / Re-stow / Shifting",
        ],

        "Inland Transport Surcharges (Road/Rail)": [
            "Waiting / Standby",
            "Layover / Trip Loss",
            "Attempted Delivery / Redelivery",
            "Address Change / Rerouting",
            "Additional Stop / Multi-drop",
            "Tolls / Road Charges",
            "Ferry / Ro-Ro Inland Crossing",
            "Capacity / Peak Season Surcharge",
            "ADR / Hazmat Surcharge",
            "Temperature-Control Premium / Reefer",
        ],

        "Customs & Documentation Extras": [
            "Customs Exam / X-Ray / Inspection",
            "Amendment / Correction Fee",
            "HS Code Review / Consultancy",
            "Bond / Guarantee / Transit Document",
            "Health / Phytosanitary Controls",
            "ISPM-15 (Wood Packaging) Inspection",
            "DG Documentation & Compliance Fee",
        ],

        "Warehouse, Handling & Distribution Extras": [
            "Warehouse Storage",
            "Palletizing / Depalletizing",
            "Sorting / Labeling / Repacking",
            "Stuffing / Stripping",
            "Cross-dock / Transfer",
            "MHE / Crane Requirement",
            "Out-of-Hours / Weekend Operations",
            "Additional Handling (Overtime)",
        ],

        "Equipment, Risk & Exceptions": [
            "Chassis Rental (especially US)",
            "Empty Repositioning / Equipment Imbalance",
            "Container Cleaning / Repair / Damage",
            "Wrong Booking / Mis-declaration Penalties",
            "Additional Cargo Insurance / Extra Coverage",
            "War Risk / Piracy / Sanctions-Related Surcharges",
            "Force Majeure Operational Costs",
        ],
    },
};
